authConfig.$inject = ['$stateProvider'];

function authConfig($stateProvider){
  $stateProvider
    .state('home.auth', {
      url: "auth/{token}",
      template: `<auth sh-ctrl="shCtrl"></auth>`
    });
}

export default authConfig;



// WEBPACK FOOTER //
// ./www/components/auth/auth.config.js